import React, { Component } from 'react';
import { Container, Row, Col, Table, Button, ButtonGroup, FormGroup, Input, Form } from 'reactstrap';
import { Link, Redirect } from 'react-router-dom';
//config
import { REST_KEY } from '../../config/config';
import Api from '../../config/Api';
import Jwt from '../../config/JWT';
//components
import Loadings from '../../components/Loading/LoadingSpiner';
import HapusBerita from '../../components/Modal/ModalHapus';
import Notif from '../../components/Notification/Notif';

export default class TableBerita extends Component {
	state = {
		token_api: REST_KEY,
		berita: [],
		idKat: '',
		search: '',
		limitb: 10,
		loading: true,
		redirect: false,
	};
	beritaList = async (e) => {
		await Api.post('berita/list', this.state).then((b) => {
			if (b.data.status) {
				this.setState({
					success: true,
					berita: b.data.rows,
					loading: false,
				});
			} else {
				Notif('e', '🔥', sessionStorage.getItem('namaP'), b.data.pesan);
			}
		});

		return false;
	};
	componentDidMount() {
		this.beritaList();
		this.responseGoogle();
	}
	selectChange = (e) => {
		this.setState({ [e.name]: e.value });
	};
	ganti = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	};
	onCariB = (e) => {
		e.preventDefault(e);
		this.setState(
			{
				loading: true,
			},
			() => this.beritaList()
		);
	};
	responseGoogle = async () => {
		let fds = new FormData();
		fds.append('id_token', localStorage.getItem('tokenId'));

		await Jwt.post('oauth2/v3/tokeninfo?', fds).then((g) => {
			if (g.status === 200) {
				this.setState(
					{
						email: g.data.email,
					},
					async () => {
						await Api.post('admin_api/login', this.state).then((login) => {
							if (login.data.status === true) {
								this.setState({
									redirect: false,
								});
							} else {
								this.setState({
									redirect: true,
								});
							}
						});
					}
				);
			} else {
				this.setState({
					redirect: true,
				});
			}
		});
	};
	render() {
		if (this.props.refresh === true) {
			this.beritaList();
		}
		if (this.state.redirect === true || !localStorage.getItem('tokenId')) {
			return <Redirect to="/" />;
		}

		let ListBerita = (
			<tr>
				<td>L</td>
				<td>O</td>
				<td>A</td>
				<td>D</td>
				<td>I</td>
				<td>N</td>
				<td>G</td>
				<td>...</td>
			</tr>
		);

		if (this.state.success === true) {
			ListBerita = this.state.berita.map((data, key) => {
				return (
					<tr className="tr-berita" key={key}>
						<td>{key + 1}</td>
						<td>
							<p>{data.kecamatan}</p>
						</td>
						<td>
							<p>{data.desa}</p>
						</td>
						<td>
							<p>{data.tps}</p>
						</td>
						<td>
							<p>{data.calon1}</p>
						</td>
						<td>
							<p>{data.calon2}</p>
						</td>
						<td>
							<p>{data.admin}</p>
						</td>
						<td>
							<ButtonGroup>
								<Link
									to={{
										pathname: '/admin/edit-data',
										data: data,
									}}
								>
									<Button className="btn-icon btn-2" color="primary" type="button">
										<span className="btn-inner--icon">
											<i className="fa fa-pencil" />
										</span>
									</Button>
								</Link>

								<HapusBerita
									judul={'HAPUSDATA!'}
									isi={
										'Data Kecamtan ' + data.kecamatan + ', Desa ' + data.desa + ', TPS ' + data.tps
									}
									id={data.id}
									tombol="TableList"
									url_wb="berita/hapus"
									refresh={this.beritaList}
								/>
							</ButtonGroup>
						</td>
					</tr>
				);
			});
		}
		return (
			<>
				<Container fluid>
					<Loadings loading={this.state.loading} />
				</Container>
				<Container className="mt-5">
					{/* <h4 className="text-center text-white text-uppercase">Daftar Suara Masuk</h4>
					<hr />
					<Link to={'/admin/tambah-berita'}>
						<Button className="btn-icon btn-2 mb-2" color="success" type="button">
							<span className="btn-inner--icon">
								<i className="fa fa-plus fa-2x" />
							</span>
						</Button>
					</Link> */}
					<Form onSubmit={this.onCariB}>
						<Row>
							<Col md="8 p-md-2">
								<FormGroup>
									<Input
										id="exampleFormControlInput1"
										placeholder="Cari Kecamatan Atau Desa"
										type="text"
										name="search"
										value={this.state.value}
										onChange={this.ganti}
									/>
								</FormGroup>
							</Col>

							<Col md="3 p-md-2">
								<FormGroup>
									<Input
										placeholder="Limit"
										type="number"
										name="limitb"
										value={this.state.limitb}
										onChange={this.ganti}
									/>
								</FormGroup>
							</Col>
							<Col md="1 p-md-2">
								<Button block className="btn-icon btn-2 mb-2" color="info" type="submit">
									<span className="btn-inner--icon">
										<i className="fa fa-search" />
									</span>
								</Button>
							</Col>
						</Row>
					</Form>

					<Table
						responsive
						bordered
						className="text-center"
						style={{
							backgroundColor: 'white',
						}}
					>
						<thead>
							<tr>
								<th>#</th>
								<th>Kecamatan</th>
								<th>Desa</th>
								<th>TPS</th>
								<th>Paslon 1</th>
								<th>Paslon 2</th>
								<th>Admin</th>
								<th></th>
							</tr>
						</thead>
						<tbody>{ListBerita}</tbody>
					</Table>
				</Container>
			</>
		);
	}
}
